export default "__VITE_ASSET__J2iJfL1h__"